module.exports = __webpack_public_path__ + "img/alipay.deaed341.svg";